<template>
	<RotationLayout :rotation="rotation" :subtitle="trans('rotations.elections.candidates.title')">
		<Empty v-if="candidates.length === 0"/>
		<Candidate v-for="candidate in candidates" :key="`candidate-${candidate.id}-${candidate.status}`" :rotation="rotation" :candidate="candidate"/>
	</RotationLayout>
</template>
<script setup lang="ts">
import {trans} from 'laravel-vue-i18n'
import Empty from '@/Components/UI/Empty.vue'
import {defineProps, type Ref, ref} from 'vue'
import RotationLayout from '@/Layouts/RotationLayout.vue'
import {type Rotation} from '@/Types/Periods/Rotations/Rotation'
import Candidate from '@/Components/Association/Representatives/Candidate.vue'
import {type RotationCandidate} from '@/Types/Periods/Rotations/RotationCandidate'

const props = defineProps<{
	rotation:Rotation,
	candidates:Array<RotationCandidate>,
}>()

const rotation:Ref<Rotation> = ref(props.rotation)
const candidates:Ref<Array<RotationCandidate>> = ref(props.candidates)
</script>